import React from "react";

export default function TradeNavitionIcon(props: any) {
  return (
    <svg width="20" height="20" viewBox="0 0 31 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.3636 14.375V2.875C25.3636 1.29375 24.0955 0 22.5455 0H2.81818C1.26818 0 0 1.29375 0 2.875V14.375C0 15.9563 1.26818 17.25 2.81818 17.25H22.5455C24.0955 17.25 25.3636 15.9563 25.3636 14.375ZM12.6818 12.9375C10.3427 12.9375 8.45455 11.0112 8.45455 8.625C8.45455 6.23875 10.3427 4.3125 12.6818 4.3125C15.0209 4.3125 16.9091 6.23875 16.9091 8.625C16.9091 11.0112 15.0209 12.9375 12.6818 12.9375ZM31 4.3125V20.125C31 21.7063 29.7318 23 28.1818 23H4.22727V20.125H28.1818V4.3125H31Z"
        fill="white"
      />
    </svg>
  );
}
